/**
 * The element ids the footer's "take me there" points at, written once and
 * read by the row that draws the control and the footer that jumps to it.
 */

export function priorArtTypeId(fileId: string): string {
  return `prior-art-type-${fileId}`;
}

export function positionRowId(positionId: string): string {
  return `position-row-${positionId}`;
}
